/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiPlayerPlayerIdGet200Response } from '../models';
// @ts-ignore
import type { ApiPlayerPlayerIdStatsGet200Response } from '../models';
/**
 * PlayerApi - axios parameter creator
 * @export
 */
export const PlayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdGet: async (playerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('apiPlayerPlayerIdGet', 'playerId', playerId)
            const localVarPath = `/api/player/{player_id}`
                .replace(`{${"player_id"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdStatsGet: async (playerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('apiPlayerPlayerIdStatsGet', 'playerId', playerId)
            const localVarPath = `/api/player/{player_id}/stats`
                .replace(`{${"player_id"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlayerApi - functional programming interface
 * @export
 */
export const PlayerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlayerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerPlayerIdGet(playerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayerPlayerIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayerPlayerIdGet(playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.apiPlayerPlayerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerPlayerIdStatsGet(playerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayerPlayerIdStatsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayerPlayerIdStatsGet(playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.apiPlayerPlayerIdStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlayerApi - factory interface
 * @export
 */
export const PlayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlayerApiFp(configuration)
    return {
        /**
         * Get player by id from Sportradar API
         * @param {PlayerApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdGet(requestParameters: PlayerApiApiPlayerPlayerIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayerPlayerIdGet200Response> {
            return localVarFp.apiPlayerPlayerIdGet(requestParameters.playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {PlayerApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdStatsGet(requestParameters: PlayerApiApiPlayerPlayerIdStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayerPlayerIdStatsGet200Response> {
            return localVarFp.apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiPlayerPlayerIdGet operation in PlayerApi.
 * @export
 * @interface PlayerApiApiPlayerPlayerIdGetRequest
 */
export interface PlayerApiApiPlayerPlayerIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayerApiApiPlayerPlayerIdGet
     */
    readonly playerId: string
}

/**
 * Request parameters for apiPlayerPlayerIdStatsGet operation in PlayerApi.
 * @export
 * @interface PlayerApiApiPlayerPlayerIdStatsGetRequest
 */
export interface PlayerApiApiPlayerPlayerIdStatsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayerApiApiPlayerPlayerIdStatsGet
     */
    readonly playerId: string
}

/**
 * PlayerApi - object-oriented interface
 * @export
 * @class PlayerApi
 * @extends {BaseAPI}
 */
export class PlayerApi extends BaseAPI {
    /**
     * Get player by id from Sportradar API
     * @param {PlayerApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public apiPlayerPlayerIdGet(requestParameters: PlayerApiApiPlayerPlayerIdGetRequest, options?: RawAxiosRequestConfig) {
        return PlayerApiFp(this.configuration).apiPlayerPlayerIdGet(requestParameters.playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get player statistics by id from Sportradar API
     * @param {PlayerApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public apiPlayerPlayerIdStatsGet(requestParameters: PlayerApiApiPlayerPlayerIdStatsGetRequest, options?: RawAxiosRequestConfig) {
        return PlayerApiFp(this.configuration).apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then((request) => request(this.axios, this.basePath));
    }
}

